import axios from 'axios'
import router from '../router'
import store from '../store'
import {
  Message,
  Loading
} from 'element-ui';

let loading = "";
// let flag = 0;
const CancelToken = axios.CancelToken;
const source = CancelToken.source();
const service = axios.create({
  baseURL: process.env.BASE_URL,
  timeout: 15000,
  cancelToken: source.token
}) 
service.interceptors.request.use(function (config) {
  if(window.location.href.indexOf('auctionDetail') == -1 && window.location.href.indexOf('jjdt') == -1){
    // flag++;
    // loading = Loading.service({
    //   lock: true,
    //   text: 'Loading',
    //   spinner: 'el-icon-loading',
    //   background: 'rgba(0, 0, 0, 0.7)'
    // });
  }
  let xzcode = window.sessionStorage.getItem('xzcode') || store.state.user.xzcode;
  config.headers.xzcode = window.location.href.split("?")[1] ? window.location.href.split("?")[1].split("=")[1] : xzcode;
  return config;
}, function (error) {
  return Promise.reject(error);
});


service.interceptors.response.use(function (response) {
  if(window.location.href.indexOf('auctionDetail') == -1 && window.location.href.indexOf('jjdt') == -1){
    // flag--;
    // if (!flag) {
    //    loading.close();
    // }
  }
  if (response.data === 911) {
    MessageBox.alert('本程序禁止xss攻击和sql注入', '风险提示', {
      confirmButtonText: '确定',
      // callback: action => {
      //   flag--;
      //   if (!flag) {
      //     loading.close();
      //   }
      // }
    });
    return
  }
  if (!response.data.success && response.data.data == "ErrorToLogin") {
    store.dispatch("LogOut");
  }
  return response;
}, function (error) {
    if(window.location.href.indexOf('auctionDetail') == -1 && window.location.href.indexOf('jjdt') == -1){
      // flag--;
    // loading.close();
    }
  return Promise.reject(error);
});
export default service



// WEBPACK FOOTER //
// ./src/utils/request.js